import { Box, Skeleton, Stack } from '@mui/material';

const QuoteSectionSkeleton = () => {
  return (
    <Box>
      <Stack
        direction="row"
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Skeleton
          variant="text"
          sx={{
            height: '48px',
            width: '100px',
            mb: 1,
          }}
        />
        <Skeleton
          variant="circular"
          sx={{
            height: '40px',
            width: '40px',
            mb: 1,
          }}
        />
      </Stack>
      <QuoteCardSkeleton />
    </Box>
  );
};
const QuoteCardSkeleton = () => {
  return (
    <Skeleton
      variant="rectangular"
      sx={(theme) => ({
        height: '64px',
        [theme.breakpoints.down('md')]: {
          height: '66px',
        },
      })}
    />
  );
};

export { QuoteCardSkeleton, QuoteSectionSkeleton };
